// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2UGYW","inner":"Form_inner__1wd7z","range":"Form_range__11-qz","name":"Form_name__3ypTp","actions":"Form_actions__1cZhw"};